import React, { useState } from 'react'
// import axios from 'axios'
import '../css/Login.css'
import api from './api'

import { useNavigate, useSearchParams, Link } from 'react-router-dom'

import { UserOutlined } from '@ant-design/icons'
import { Button, Form, Input, message } from 'antd'


import Logo from '../images/logo.png'


//  找回密码布局
function Forget_Password(props) {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [search] = useSearchParams()

    //  跳转
    function loginAction() {
        var redirect = search.get("redirect") || "/"
        navigate(redirect, { replace: true })
    }

    //  提交登陆
    function onFinish(values) {
        setLoading(true)
        setTimeout(() => {
            api.post('/api/v2/user/forget_password', {
                email: values.email,
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        message.success('系统已将找回密码邮件发送至您的邮箱中, 请查收邮件~')
                        loginAction()
                    } else {
                        message.error(res.data.data.text)
                        setLoading(false)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                    setLoading(false)
                })
        }, 500);
    }

    return (
        <div className='login forget_password'>
            <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
            >
                <div className='logo animate__animated animate__lightSpeedInLeft'>
                    <Link to="/">
                        <img src={Logo} alt='logo'></img>
                    </Link>
                </div>

                <Form.Item
                    name="email"
                    rules={[
                        {
                            required: true,
                            type: 'email',
                            message: '请输入正确的邮箱地址!',
                        },
                    ]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="邮箱地址" />
                </Form.Item>

                <Form.Item>
                    <div id="demo"></div>
                    <Button type="primary" htmlType="submit" shape="round" className="login-form-button" loading={loading}>找回密码</Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default Forget_Password;